import { Injectable } from '@angular/core';
import { NotificationService, Notification } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class BellToasterNotificationService {
  constructor(private readonly notificationService: NotificationService) {}

  receiveMessage(onMessage: (notification: Notification) => void) {
    this.notificationService.messages.subscribe((notification) => {
      if (notification && notification?.template?.name === 'bellToaster') {
        onMessage(notification);
      }
    });
  }
}
